import React, { useEffect, useState } from "react";
import './DashboardPage.css';
import Navbar from "../../ui/Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getOfficeActiveSessionsAsync, getOfficeSessions, getCurrentSessionId, getLoadingOfficeSessions } from "../../../features/redux/appSlice";

function DashboardPage() {
    const dispatch = useDispatch();
    const officeSessions = useSelector(getOfficeSessions);
    const currentSessionId = useSelector(getCurrentSessionId);
    const isLoadingSessions = useSelector(getLoadingOfficeSessions);
    const [currentSession, setCurrentSession] = useState(null);
    
    useEffect(() => {
        if (currentSessionId) {
            dispatch(getOfficeActiveSessionsAsync(currentSessionId));
        }
    }, [currentSessionId, dispatch]);

    useEffect(() => {
        if (currentSessionId) {
            const session = officeSessions.find(s => s.id === currentSessionId);
            setCurrentSession(session);
        }
    }, [currentSessionId, officeSessions]);

    return (
        <div className="dashboard-wrapper">
            <Navbar />
            <div className="active-sessions-content">
                {currentSessionId ? (
                    isLoadingSessions ? (
                        <p>Loading active sessions...</p>
                    ) : (
                        officeSessions.length > 0 ? (
                            <ul>
                                {officeSessions.map(session => (
                                    <li key={session.id} className="session-card">
                                        {session.User && session.User.profile && session.User.profile.passport_image && (
                                            <img 
                                                src={`data:image/jpeg;base64,${session.User.profile.passport_image}`} 
                                                alt="User" 
                                                className="user-image" 
                                            />
                                        )}
                                        <div className="session-details">
                                            <p><strong>{session.User ? session.User.name : 'Unknown User'}</strong></p>
                                            <p>{session.start}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No active sessions</p>
                        )
                    )
                ) : (
                    <p>Select an office to view active sessions</p>
                )}
            </div>
        </div>
    );
}

export default DashboardPage;
